<template>
  <div class="field" style="margin-bottom: 1rem;">
    <div
      class="ui primary basic button"
      @click="showModal"
      :class="{ 'right floated': isRightFloated }">
      <i class="add icon"/>
      <span v-if="itemType === 'lesson'">{{ $t('newPlanModule.new.lesson') }}</span>
      <span v-if="itemType === 'action'">{{ $t('newPlanModule.new.action') }}</span>
    </div>
    <div
      class="ui basic mini modal"
      :id="modalId">
      <div
        class="ui icon header"
        v-if="itemType === 'lesson'">
        {{ $t('newPlanModule.create.lesson') }}
      </div>
      <div
        class="ui icon header"
        v-if="itemType === 'action'">
        {{ $t('newPlanModule.create.action') }}
      </div>
      <div class="content">
        <div
          class="ui form"
          :id="formId">
          <div class="field">
            <div class="ui labeled input">
              <div class="ui grey label">
                {{ $t('newPlanModule.name') }}
              </div>
              <input
                name="title"
                type="text"
                placeholder="Keep it short and simple"
                v-model.trim="newPlanName">
            </div>
          </div>
        </div>
        <br>
        <p><i>{{ $t('newPlanModule.message') }}</i></p>
      </div>
      <div class="actions" style="padding-left: 1.5rem; padding-right: 1.5rem;">
        <div
          class="ui left floated inverted button"
          style="margin-left: 0; margin-right: 0;"
          @click.prevent="resetValue">
          {{ $t('newPlanModule.cancel') }}
        </div>
        <div
          class="ui inverted primary button"
          style="margin-left: 0; margin-right: 0;"
          @click.prevent="postPlan">
          {{ $t('save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DraftProgramPlan } from '../structs/structs'

export default {
  name: 'NewPlanModule',
  props: {
    isRightFloated: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: String,
      required: true
    },
    programPlans: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      newPlanName: ''
    }
  },
  computed: {
    modalId () { return `new-plan-modal-${this._uid}` },
    formId () { return `new-plan-form-${this._uid}` },
    planObject () {
      return new DraftProgramPlan(
        {
          planType: this.itemType,
          attribute: 'NVSCoaching',
          programId: process.env.VUE_APP_PROGRAM_ID,
          data: {
            title: this.newPlanName,
            deletedStatus: false,
            childPlans: []
          }
        }
      )
    },
    planNames () {
      return (
        this.programPlans
          .map(plan => (typeof plan.data.title === 'string' || '') && plan.data.title.trim().toLowerCase())
      )
    },
    newPlanNameIsADuplicate () {
      return this.planNames.includes((this.newPlanName) && this.newPlanName.trim().toLowerCase())
    }
  },
  methods: {
    initializeFormValidation: function () {
      // Note: using regex to polyfill for the trim function so that it will work on old browsers too
      $.fn.form.settings.rules.whitespaces = () => {
        return (this.newPlanName.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '') !== '')
      }

      $.fn.form.settings.rules.newPlanNameIsADuplicate = () => {
        return !this.newPlanNameIsADuplicate
      }

      $('#' + this.formId).form({
        fields: {
          'title': {
            identifier: 'title',
            rules: [
              { type: 'empty', prompt: this.$t('validations.cannotBeEmpty', { item: this.$t('validations.planTitle') }) },
              { type: 'whitespaces', prompt: this.$t('validations.noWhitespace', { item: this.$t('validations.planTitle') }) },
              { type: 'newPlanNameIsADuplicate', prompt: this.$t('validations.duplicatePlanTitle') }
            ]
          }
        },
        inline: true
      })
    },
    resetValue: function () {
      this.newPlanName = ''
      $('#' + this.modalId).modal('hide')
    },
    showModal: function () {
      this.newPlanName = ''
      $('#' + this.modalId).modal({ closable: false }).modal('show')
    },
    postPlan: function () {
      let validationStatus = $('#' + this.formId).form('validate form')
      if (validationStatus === true) {
        let requestUrl = process.env.VUE_APP_PROGRAM_URL + '/programPlanTemplate'
        this.$axios.post(
          requestUrl,
          this.planObject,
          this.requestConfig
        ).then(
          response => {
            this.resetValue()
          }
        )
      } else {
        $('#' + this.formId).form('validate form')
      }
    }
  },
  mounted () {
    this.initializeFormValidation()
  },
  beforeDestroy () {
    let modal = $('#' + this.modalId)
    if (modal !== null) {
      modal.remove()
    }
  }
}
</script>

<style>
  .dimmable,  .dimmed, .dimmer {
    margin: 0;
    padding: 0;
  }

</style>
